import React from "react";

// Renders a string, highlighting any "[TODO: …]" placeholder so an unfilled
// value is impossible to miss on the page (and in a screenshot).
const SPLIT_RE = /(\[TODO:[^\]]*\])/g;
const IS_TODO = /^\[TODO:[^\]]*\]$/;

const TodoText = ({ children }) => {
  if (typeof children !== "string") return children || null;
  if (!children.includes("[TODO:")) return children;

  return (
    <>
      {children.split(SPLIT_RE).map((part, i) =>
        IS_TODO.test(part) ? (
          <span key={i} className="legal-todo">{part}</span>
        ) : (
          <React.Fragment key={i}>{part}</React.Fragment>
        )
      )}
    </>
  );
};

export default TodoText;
